<template>
  <confirmation-dialog v-model="isOpeded" :action="action" confirm-text="Удалить">
    <template v-if="slots.activator" #activator>
      <slot name="activator" />
    </template>

    <div class="h3 mb-6">Удаление уже опубликованной информации</div>
    <div class="paragraph-l text-secondary">Данные будут потеряны и сняты с публикации после отправки анкеты</div>
  </confirmation-dialog>
</template>
<script setup lang="ts">
import ConfirmationDialog from '@/core/components/modals/ConfirmationDialog.vue';

defineProps<{
  action: () => Promise<boolean | void> | boolean | void;
}>();

const slots = defineSlots<{
  activator: (props: unknown) => void;
}>();

const isOpeded = defineModel<boolean>({ required: true });
</script>
